<template>
	<template v-if="favorites.length !== 0">
	<h3 class="heading2"><i class="glyphicon glyphicon-star"></i> お気に入り</h3>
	<div class="more">
		<a v-link="{path: '/favorites'}" class="headingSet__more"><i class="glyphicon glyphicon-arrow-right"></i> 一覧を見る</a>
	</div>
	<ul class="linkList">
		<li v-for="(index, item) in favorites" v-if="item !== null && $index < view">
			<a v-link="{path: '/detail/' + item.id}">
				<div class="flexColumn">
					<div class="flexColumn__col1">
						<img v-bind:src="item.thumbnail" class="img-responsive" alt="">
					</div>
					<div class="flexColumn__col2">
						<h4 v-text="item.name" class="heading3"></h4>
						<!-- <p v-text="item.promoword" class="pr"></p> -->
					</div>
				</div>
			</a>
		</li>
	</ul>
	<ul style="display: none;">
		<li v-for="item in favorites | limitBy 5">
			{{$index}}: {{item.id}}
		</li>
	</ul>
	</template>
</template>

<script>
module.exports = {
	route: {
		data: function(transition){
		},
		canReuse: false
	},
	data: function(){
		return {
			favorites: [],
			view: 5,
			nullCount: 0,
			reload: {
				times: 3,
				delay: 5000
			}
		};
	},
	created: function() {
		this.$on('receiveFavAction', function(args) {
			this.editFavorites(args);
		});

		this.$on('receiveRefreshFavorites', function(){
			this.favorites = [];
			this.getFavorites();
		});

		// get favorites
		this.getFavorites();

		this.$on('debug', function(args) {
			console.log(args);
		});
	},
	ready: function(){
		// console.log(this.$parent);
		// this.$emit('debug', this.favorites);

		// this.$watch('favorites', function(){
		//
		// });
		// for (var i = 0; i < this.favorites.length; i++){
		// 	if (Object.keys(this.favorites[i]).length === 0){
		// 		this.favorites.$remove(this.favorites[i]);
		// 	}
		// }
	},
	methods: {
		devMode: function(){
			return this.$route.devmode;
		},
		createJsonPath: function(profile_id){
			var devmode = this.devMode();
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var apipath = host + '//' + hostname + '/s/api/';
			var url = devmode ? '/static/json/sample_detail.json' : apipath + 'profile/' + profile_id;
			return url;
		},
		getJson: function(url, index = '', times = this.reload.times, delay = this.reload.delay){
			var devmode = this.devMode();
			this.$http.get(url).then(function (response) {
				// success callback
				var json = response.data;
				// console.log(json.Profiles.img_1);
				var dataObj = null;

				if (json.length !== 0 && Object.keys(json).length !== 0){
					var thumbFileName = '';
					if (json.Profiles.img_1){
						var imgDir = devmode ? '/static/images/sample_studio/' : '/s/img/studio/';
						thumbFileName = imgDir + json.Profiles.img_1.replace(/^(.+)(\.[a-z]+)$/, '$1_thumbnail$2');
					} else {
						thumbFileName = '/static/images/thumb/no_image_r.jpg';
					}

					dataObj = {
						id: json.Profiles.id,
						name: json.Profiles.name,
						promoword: json.Profiles.promoword,
						thumbnail: thumbFileName
					};

					// if (index !== ''){
					// 	this.favorites.$set(index, dataObj);
					// } else {
					// 	this.favorites.unshift(dataObj);
					// }
				} else {
					// this.nullCount = this.nullCount + 1;
					// this.favorites.$remove(this.favorites[index]);
				}

				if (index !== ''){
					this.favorites.$set(index, dataObj);
				} else {
					this.favorites.unshift(dataObj);
				}
				// console.log(this.favorites);
			}, function (response) {
				// error callback
				console.log(response.status);
				console.log('データの取得に失敗しました');
				if (times > 0){
					setTimeout(this.getJson, delay, url, index, times - 1, delay);
				}
			});
		},
		getFavorites: function(){
			var cr_v = String(window.localStorage.getItem('fav'));
			var encodedUndef = encodeURIComponent(',undefined');
			var undefStr = new RegExp(encodedUndef, 'g');
			if (cr_v.match(undefStr) !== null){
				var remove_v = cr_v.replace(undefStr, '');
				window.localStorage.setItem('fav', remove_v);
			}

			var favArr = cr_v.split('%2C');
			favArr = favArr.filter(function(e){
				return e !== '';
			});
			favArr.reverse();
			// console.log(favArr);

			for (var i = 0; i < favArr.length; i++){
				var url = this.createJsonPath(favArr[i]);
				this.getJson(url, i);
			}
		},
		editFavorites: function(args){
			// var rc = args;
			var id = args;
			var cr_v = String(window.localStorage.getItem('fav'));
			var favArr = cr_v.split('%2C');
			favArr = favArr.filter(function(e){
				return e !== '';
			});

			// if (rc.length !== 0){
			// 	for (var i = 0; i < rc.length; i++){
			// 		if (favArr.indexOf(rc[i]) === -1){
			// 			for (var item in this.favorites){
			// 				if (this.favorites[item].id === rc[i]){
			// 					this.favorites.splice(item, 1);
			// 				}
			// 			}
			// 		} else {
			// 			var url = this.createJsonPath(rc[i]);
			// 			this.getJson(url);
			// 		}
			// 	}
			// }
			if (favArr.indexOf(id) === -1){
				// remove
				for (var item in this.favorites){
					if (this.favorites[item].id === id){
						// this.favorites.$set(item, '');
						this.favorites.splice(item, 1);
					}
				}
			} else {
				var url = this.createJsonPath(id);
				this.getJson(url);
			}

			// console.log(this.favorites);
		}
	}
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// widget_favorites.vue?938d003e